import { Directive, ElementRef, HostListener } from "@angular/core";
import { environment } from "src/environments/environment";

@Directive({
  selector: "[vwProductImageFallback]",
})
export class ProductImageFallbackDirective {
  constructor(private eRef: ElementRef<HTMLImageElement>) {}

  @HostListener("error")
  setFallbackOnError(): void {
    const element: HTMLImageElement = this.eRef.nativeElement;
    element.src = environment.productImageFallbackURL;
  }
}
